import React, { useEffect, useState, useRef ,useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSlate } from 'slate-react'
import { useForm, useFieldArray, Controller } from 'react-hook-form'
import clsx from 'clsx';
import {Nav,Row,TabContent,TabPane, NavItem, NavLink} from 'reactstrap'

import { useEditorState, useEditorActions, useEditorDispatch, UPDATE_VARIABLE } from '../../../editor-context'
import { removeNodesById, scrollToNode } from '../../../Canvas/TratoFormat'
import { camelize } from 'utils'
import useDebounce from 'hooks/useDebounce'
import useMemoCompare from 'hooks/useMemoCompare'
import {General} from './General'
import {ParticipantList} from './ParticipantList'
import {SpectatorList} from './SpectatorList'
const getTabs = ({ t, isParticipantsOk, isConfigOk }) => {
    return [{
        id: 'general',
        label: t('editor.config.general'),
        hasError: () => !isConfigOk,
        Component: General
    },{
        id: 'participants',
        label: t('editor.config.participants'),
        hasError: () => !isParticipantsOk,
        Component: ParticipantList
    },{
        id: 'spectators',
        label: t('editor.config.spectators'),
        hasError: () => false,
        Component: SpectatorList
    }]
    
}


export function Configuration() {
    const { t } = useTranslation()
    const { document: doc, isConfigOk, isParticipantsOk} = useEditorState()
    const tabs = getTabs({ t, isConfigOk, isParticipantsOk });
    const [currentTab, setCurrentTab] = useState(tabs[0]);

    // TODO: change to casl
    const errors = false

    const handleTabClick = (tab) => () => {
        setCurrentTab(tab);
    }

    return (
        <div className="bg-light">
            <Nav className="" tabs fill>
                {tabs.map((tab) =>
                    <NavItem key={`tab-${tab.id}`} onClick={handleTabClick(tab)}>
                        <NavLink className={clsx('p-1', tab.id === currentTab.id ? 'active bg-light border-bottom-light' : 'bg-white text-dark')}>
                            <span className={clsx(errors && 'errors')}>
                                {tab.label}{' '}
                                {tab.hasError() && <i className="fas fa-exclamation-triangle text-warning"></i>}
                            </span>
                        </NavLink>
                    </NavItem>
                )}
            </Nav>
            <TabContent activeTab={1} className="">
                {currentTab.Component &&
                    <TabPane tabId={1} >
                        <currentTab.Component />
                    </TabPane>
                }
            </TabContent>
        </div>    
    )
}